import { render, staticRenderFns } from "./PlatformManagerDialog.vue?vue&type=template&id=276c4900&scoped=true&lang=pug&"
import script from "./PlatformManagerDialog.vue?vue&type=script&lang=ts&"
export * from "./PlatformManagerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276c4900",
  null
  
)

export default component.exports